// extracted by mini-css-extract-plugin
var _1 = "OrganizationOnboardingStepInvite-module__animateUploadProgressBarWidth--eL2dY";
var _2 = "OrganizationOnboardingStepInvite-module__animatedBackground--NRKAb";
var _3 = "OrganizationOnboardingStepInvite-module__buttonCaret--Zp2y2";
var _4 = "OrganizationOnboardingStepInvite-module__expandableSection--suTpi";
var _5 = "OrganizationOnboardingStepInvite-module__expanded--ivHpw";
var _6 = "OrganizationOnboardingStepInvite-module__invitesLegend--yvbm7";
var _7 = "OrganizationOnboardingStepInvite-module__invitesLegendText--Jc0Ta";
var _8 = "OrganizationOnboardingStepInvite-module__linkIcon--mjtMK";
var _9 = "OrganizationOnboardingStepInvite-module__note--nI5Bu";
var _a = "OrganizationOnboardingStepInvite-module__provisionLink--HwqBL";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttonCaret", _4 as "expandableSection", _5 as "expanded", _6 as "invitesLegend", _7 as "invitesLegendText", _8 as "linkIcon", _9 as "note", _a as "provisionLink" }
